<template>
  <div>
    <div class="text-center mb-5">
      <h1 class="mb-5">
        <strong>Dobrodošli na the<span class="text-primary">HR</span> platformu</strong>
      </h1>
      <p>
        Sistem za upravljanje kadrovima.
      </p>
    </div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-3">
        <strong>Prijavite se na svoj nalog</strong>
      </div>
      <div class="mb-4">
        <a-radio-group
          :value="settings.authProvider"
          @change="e => changeAuthProvider(e.target.value)"
        >
          <a-radio value="firebase">Firebase</a-radio>
          <!-- <a-radio value="jwt">JWT</a-radio> -->
          <a-tooltip>
            <template slot="title">
              <span>Read Docs Guide</span>
            </template>
            <!-- <a-radio value="auth0" disabled>Auth0</a-radio> -->
          </a-tooltip>
          <a-tooltip>
            <template slot="title">
              <span>Read Docs Guide</span>
            </template>
            <!-- <a-radio value="strapi" disabled>Strapi</a-radio> -->
          </a-tooltip>
        </a-radio-group>
      </div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            v-decorator="['email', { initialValue: '', rules: [{ required: true, message: 'Unesite vaš email!' }]}]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Lozinka"
            type="password"
            v-decorator="['password', {initialValue: '', rules: [{ required: true, message: 'Unesite vašu lozinku!' }]}]"
          />
        </a-form-item>
        <a-button
          type="primary"
          htmlType="submit"
          size="large"
          class="text-center w-100"
          :loading="loading"
        >
          <strong>Prijavljivanje</strong>
        </a-button>
      </a-form>
      <router-link to="/auth/forgot-password" class="kit__utils__link font-size-16">Zaboravili ste lozinku?</router-link>
    </div>
    <div class="text-center pt-2 mb-auto">
      <span class="mr-2">Nemate nalog?</span>
      <router-link to="/auth/register" class="kit__utils__link font-size-16">Napravite nalog sada</router-link>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'CuiLogin',
  computed: {
    ...mapState(['settings']),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    changeAuthProvider(value) {
      this.$store.commit('CHANGE_SETTING', { setting: 'authProvider', value })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('user/LOGIN', { payload: values })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
